export type SortingMode = 'Direction' | 'Other';

export const SortingMode = {
  Direction: 'Direction' as SortingMode,
  Other: 'Other' as SortingMode
}